import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M14 3v4a1 1 0 0 0 1 1h4","key":"svg-0"}],["path",{"d":"M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2","key":"svg-1"}],["path",{"d":"M12 17v.01","key":"svg-2"}],["path",{"d":"M12 14a1.5 1.5 0 1 0 -1.14 -2.474","key":"svg-3"}]]

const IconFileUnknown = createReactComponent('outline', 'file-unknown', 'FileUnknown', __iconNode);

export default IconFileUnknown;